import React from 'react';

const WhatsApp = () => {
  const phoneNumber = '03194622938';
  const message = 'Hi! I am interested in your powerlifting services. Please provide more information about your training programs, pricing, and availability.';

  const handleWhatsAppClick = () => {
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div 
      className="whatsapp-float" 
      onClick={handleWhatsAppClick}
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        width: '60px',
        height: '60px',
        backgroundColor: '#25D366',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        boxShadow: '0 4px 20px rgba(37, 211, 102, 0.4)',
        zIndex: 1000,
        transition: 'all 0.3s ease',
        animation: 'pulse 2s infinite'
      }}
    >
      <svg 
        width="32" 
        height="32" 
        viewBox="0 0 32 32" 
        fill="none" 
        style={{
          color: 'white'
        }}
      >
        <path 
          d="M16 2C8.28 2 2 8.28 2 16C2 19.66 3.36 22.98 5.64 25.46L4.02 28.94C3.74 29.48 4.24 30.08 4.8 29.86L9.04 28.2C10.88 29.2 12.92 29.74 15 29.74C22.72 29.74 29 23.46 29 15.74C29 8.02 22.72 1.74 16 1.74V2ZM22.92 21.9C22.66 22.42 21.9 22.72 20.74 22.18C19.58 21.64 17.6 20.74 15.2 18.6C13.18 16.8 11.94 14.82 11.48 12.66C11.14 11.12 11.64 10.4 11.9 10.04C12.16 9.68 12.6 9.52 12.98 9.52C13.14 9.52 13.28 9.54 13.4 9.56C13.76 9.62 13.94 9.68 14.14 10.26C14.38 10.96 14.94 12.56 15 12.76C15.06 12.96 15.1 13.2 14.98 13.44C14.86 13.68 14.8 13.76 14.64 13.94C14.48 14.12 14.34 14.28 14.18 14.44C14.02 14.6 13.86 14.76 14.04 15.06C14.22 15.36 15 16.52 16.12 17.5C17.48 18.7 18.6 19.16 18.96 19.32C19.26 19.46 19.52 19.44 19.72 19.22C19.94 18.98 20.44 18.4 20.92 17.84C21.32 17.36 21.82 17.44 22.38 17.64C22.94 17.84 24.58 18.58 24.96 18.76C25.34 18.94 25.58 19.02 25.66 19.18C25.74 19.34 25.74 20.06 25.48 20.58L22.92 21.9Z" 
          fill="currentColor"
        />
      </svg>
      
      <style jsx>{`
        @keyframes pulse {
          0% {
            box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.7);
          }
          70% {
            box-shadow: 0 0 0 10px rgba(37, 211, 102, 0);
          }
          100% {
            box-shadow: 0 0 0 0 rgba(37, 211, 102, 0);
          }
        }
        
        .whatsapp-float:hover {
          transform: scale(1.1);
          box-shadow: 0 6px 25px rgba(37, 211, 102, 0.6);
        }
        
        @media (max-width: 768px) {
          .whatsapp-float {
            width: 55px;
            height: 55px;
            bottom: 15px;
            right: 15px;
          }
        }
      `}</style>
    </div>
  );
};

export default WhatsApp;